import { render } from "./EditIncident.vue?vue&type=template&id=68d75382&ts=true"
import script from "./EditIncident.vue?vue&type=script&lang=ts"
export * from "./EditIncident.vue?vue&type=script&lang=ts"

import "./EditIncident.vue?vue&type=style&index=0&id=68d75382&lang=css"

import exportComponent from "C:\\Users\\Pablo\\Documents\\Programacion\\Playas\\beachguard_v3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__